import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import { green } from '@material-ui/core/colors'
import Box from '@material-ui/core/Box'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@graniot/common/context/AuthContext'
import Grid from '@material-ui/core/Grid'
import CircularProgress from '@material-ui/core/CircularProgress'

import { useAddContactRequestMutation } from '@graniot/common/adapters/concactrequest'

const styles = (theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
})

const DialogTitle = withStyles(styles)((props) => {
	const { children, classes, onClose, ...other } = props
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton
					aria-label="close"
					className={classes.closeButton}
					onClick={onClose}
				>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	)
})

const DialogContent = withStyles((theme) => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiDialogContent)

const DialogActions = withStyles((theme) => ({
	root: {
		margin: 0,
	},
}))(MuiDialogActions)

const DialogFreeTrial = ({ open, setOpen }) => {
	const { t } = useTranslation()
	const { loggedUser } = useAuth()

	const addContactRequest = useAddContactRequestMutation()

	const handleDialog = () => {
		setOpen(!open)
	}

	const handleAddRequest = () => {
		addContactRequest.mutate({
			content: 'subscription renewal inquiry',
			user: loggedUser.id,
		})
	}

	return (
		<>
			<Dialog
				aria-labelledby="customized-dialog-title"
				open={open}
				onClose={handleDialog}
				maxWidth={'sm'}
			>
				<DialogTitle
					id="customized-dialog-title"
					onClose={handleDialog}
				></DialogTitle>
				<DialogContent>
					<Typography
						gutterBottom
						style={{
							color: '#003945',
							fontWeight: 500,
							fontSize: 20,
							textAlign: 'center',
						}}
					>
						{t(
							'Upgrade_to_get_this_and_many_more_features'
						)}
					</Typography>
					<Typography
						gutterBottom
						style={{
							color: '#003945',
							fontWeight: 400,
							fontSize: 16,
							textAlign: 'center',
						}}
					>
						{t('AlertEndTrial.subtitle_trial')}
					</Typography>
				</DialogContent>
				<DialogActions style={{ textAlign: 'center' }}>
					<Grid container spacing={1}>
						<Grid item xs={12}>
							{addContactRequest.isSuccess ? (
								<Box p={1}>
									<Button
										variant="outlined"
										disableElevation
										style={{ color: green[500] }}
										size="large"
									>
										{t('Alert3x3.text7')}
									</Button>
								</Box>
							) : (
								<Box p={1}>
									<Button
										variant="contained"
										disableElevation
										onClick={handleAddRequest}
										style={{
											backgroundColor: '#DB491B',
											color: '#fff',
											fontWeight: 'bold',
											width: '100%',
										}}
										size="large"
										startIcon={
											addContactRequest.isLoading && (
												<CircularProgress
													color="inherit"
													size={20}
												/>
											)
										}
									>
										{t('AlertEndTrial.cta')}
									</Button>
								</Box>
							)}
						</Grid>
						<Grid item xs={12}>
							<Typography
								variant="body2"
								style={{
									textAlign: 'center',
									color: '#003945',
									paddingBottom: 8,
								}}
							>
								{t('AlertEndTrial.or_email')}{' '}
								<a
									href="mailto:info@graniot.com"
									style={{ color: '#1FC3B4' }}
								>
									info@graniot.com
								</a>
							</Typography>
						</Grid>
					</Grid>
				</DialogActions>
			</Dialog>
		</>
	)
}

export default DialogFreeTrial
